
<template>
  <div class="box">
    <img class="image" src="https://ai-ewg1990.oss-cn-guangzhou.aliyuncs.com/20250306/2cb8a55ee7adbaab8e67a7507b61edd6-741226510114710052.png" alt="">
    <div class="mainBox">
      <div class="loginBox">
        <div class="title">仪问天下</div>
        <div class="fTiele">为中国制企业批量培养AI数字员工</div>
        <div class="item" style="">
          <div class="flexMainXYcenter login_select_box" style="">
            <div class="textItem" @click="cleTimeFun" :style="{ borderBottom: active == 1? '3px solid #00D1FF' : '', color: active == 1? '#FFFFFF' : ''}">
              账号密码登录
            </div>
            <div class="textItem" @click="active = 2" :style="{ borderBottom: active != 1? '3px solid #00D1FF' : '', color: active != 1? '#FFFFFF' : '', }">
              短信验证码登录
            </div>
          </div>
        </div>
        <div style="width: 85%;">
          <div v-if="active == 1" class="boxInput">
            <img class="box_input_icon" style="" src="https://ai-ewg1990.oss-cn-guangzhou.aliyuncs.com/20250320/68bae9035731563762cc5d1052b004e1-742459172799494365.png" alt="">
            <div class="text">账 号</div>
            <el-input class="inputSty" v-model="form.phone_num" placeholder="请输入账号"></el-input>
          </div>
          <div v-if="active == 1" class="boxInput">
            <img class="box_input_icon" style="" src="https://ai-ewg1990.oss-cn-guangzhou.aliyuncs.com/20250320/40037ffb1c84ffca4d2e36b0bcc26df6-742459257439467815.png" alt="">
            <div class="text" style="border-right: 1px solid #999999;">密 码</div>
            <el-input class="inputSty" placeholder="请输入密码" v-model="form.password" show-password></el-input>
          </div>
          <div v-if="active != 1" class="boxInput">
            <img class="box_input_icon" style="" src="https://ai-ewg1990.oss-cn-guangzhou.aliyuncs.com/20250320/68bae9035731563762cc5d1052b004e1-742459172799494365.png" alt="">
            <div class="text" style="padding-right: 0;">手机号</div>
            <el-input class="inputSty" v-model="formCode.phone_num" placeholder="请输入手机号"></el-input>
          </div>
          <div v-if="active != 1" class="boxInput">
            <img class="box_input_icon" style="" src="https://ai-ewg1990.oss-cn-guangzhou.aliyuncs.com/20250320/40037ffb1c84ffca4d2e36b0bcc26df6-742459257439467815.png" alt="">
            <div class="text" style="padding-right: 0;">验证码</div>
            <el-input class="inputSty" placeholder="请输入验证码" v-model="formCode.code"></el-input>
            <span @click="codeFun" class="getCodeBtn" style="">{{ codeText }}</span>
          </div>
          <!-- <div style="margin-top: 20px;">
            <el-radio-group v-model="loginType">
              <el-radio :label="1">登录跳转到首页</el-radio>
              <el-radio :label="2">登录跳转到后台</el-radio>
            </el-radio-group>
          </div> -->
          <div class="flexMainXYcenter login_agree_box" style="">
            <el-checkbox v-model="checked"></el-checkbox>
            <div style="margin-left: 10px;color: #fff;margin-bottom: 4px;">我同意<span style="color: #00D1FF;">《服务条款》</span>和<span style="color: #00D1FF;">《隐私政策》</span></div>
          </div>
          <div @click="loginFun" class="loginSty">登录</div>
        </div>
        
      </div>
    </div>
  </div>
</template>


<script>
  import md5 from 'js-md5';
  import WKSDK from "wukongimjssdk"
  export default {
    name: 'Login',
    data () {
      return {
        loginType: 2, // 1首页 2后台
        checked: false,
        active: 1,
        userName: '',
        password: '',
        codeText: '获取验证码',
        intTer: null,
        form: {
          phone_num: '',
          password: ''
          
        },
        formCode: {
          phone_num: '',
          code: '',
        },
      }
    },
    created() {
    },
    mounted() {
      const token = localStorage.getItem("token")
      if (token) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
          this.$router.push({
            path: '/app'
          })
        }, 2000);
        // this.$router.push({
        //   path: '/agent_use_new'
        // })
      }
    },
    methods: {
      loginFun() {
        
        let that = this;
        if (this.active == 1) {
          if (!this.form.phone_num || !this.form.password) {
            this.$message({
              message: '请输入用户名和密码',
              type: 'warning'
            });
            return
          }
          if (!this.checked) {
            this.$message({
              message: '请勾选同意服务条款',
              type: 'warning'
            });
            return
          }
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
            loading.close();
          }, 2000);
          this.$post(
            {
              context: that,
              path: '/user/login/password/',
              params: {
                phone_num: this.form.phone_num,
                password: md5(this.form.password)
              },
              success: function (data) {
                that.form = {};
                localStorage.setItem("token", data.token);
                localStorage.setItem("userId", data.userId);
                that.dialogVisible = false;
                that.syncData(data.userId,data.token)
                that.initIm()
                if (that.intTer) {
                  clearInterval(that.intTer);
                }
                that.timer = null
                if (that.loginType == 1) {
                  location.reload();
                } else {
                  that.$router.push({path: '/app'});
                }
                 
              }
            }
          )
        } else {
          if (!this.formCode.phone_num) {
            this.$message({
              message: '请输入手机号和验证码',
              type: 'warning'
            });
            return
          }
          if (!this.checked) {
            this.$message({
              message: '请勾选同意服务条款',
              type: 'warning'
            });
            return
          }
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
            loading.close();
          }, 2000);
          that.$post(
              {
                context: that,
                path: '/user/login/code/',
                params: {
                  phone_num: this.formCode.phone_num,
                  code: this.formCode.code, //this.formCode.code
                },
                success: function (data) {
                  that.form = {};
                  localStorage.setItem("token", data.token);
                  localStorage.setItem("userId", data.userId);
                  that.dialogVisible = false;
                  that.syncData(data.userId,data.token)
                  that.initIm()
                  if (that.intTer) {
                    clearInterval(that.intTer);
                  }
                  that.timer = null
                  if (that.loginType == 1) {
                    location.reload();
                  } else {
                    that.$router.push({path: '/app'});
                  }
                }
              }
            )
        }
        
      },
      syncData(userId, token){
        try {
          if (window.pywebview) {
            window.pywebview.api.save_user_data(userId,token).then(function (response) {
            });
          }
        }catch (e){
          console.log(e)
        }
      },
      cleTimeFun() {
        this.active = 1;
        // clearInterval(this.intTer);
        // this.intTer = null
        // this.codeText = '获取验证码'
      },
      initIm() {
        const token = localStorage.getItem("token")
        if (!token) {
          return
        }

        let t = this;
        this.$get(
          {
            context: t,
            path: '/im/login/',
            params: {},
            success: function (data) {
              console.log(data)
              if (data.uid) {
                WKSDK.shared().config.addr = data.api;
                WKSDK.shared().config.uid = data.uid;
                WKSDK.shared().config.token = data.token;
                WKSDK.shared().connectManager.connect();
                WKSDK.shared().connectManager.addConnectStatusListener(
                  (status, reasonCode) => {
                    console.log(status)
                    if (status === 1) {
                      console.log('连接成功');
                    } else {
                      console.log('连接失败', reasonCode); //  reasonCode: 2表示认证失败（uid或token错误）
                    }
                  },
                );

              }
            }
          }
        )
      },
      codeFun() {
        if (this.codeText == '获取验证码') {
          if (!this.formCode.phone_num) {
            this.$message({
              message: '请输入手机号',
              type: 'warning'
            });
            return
          }
          let time = 60
          this.codeText = 60 + 's'
          if (this.intTer) {
            clearInterval(this.intTer)
          }
          this.intTer = setInterval(() => {
            time--
            this.codeText = time + 's'
            if (time == 1) {
              this.codeText = '获取验证码'
              clearInterval(this.intTer)
            }
          }, 1000)
          
          let that = this;
          that.$post(
            {
              context: that,
              path: '/system/verify/code/send/',
              params: {
                phone_num: that.formCode.phone_num,
              },
              success: function (data) {
                console.log(data);
              }
            }
          )
        
        }
      },
    }
  }
</script>

<style scoped>
 .box {
  background-image: url("https://ai-ewg1990.oss-cn-guangzhou.aliyuncs.com/20250320/afb2d0911fd3aadfa7cbfe980d0f9704-742455174260500144.png");
  width: 100%;
  height: 100vh;
  /* overflow: hidden; */
  background-repeat: no-repeat;
  background-origin: center center;
  background-size: 100% 100%;
  position: relative;
 }
 .image {
  width: 145px;height: 34px;
  position: absolute;
  top: 36px;
  left: 60px;
 }
 .mainBox{
  padding-top: 10%;
  padding-left: 15%;
 }
 .loginBox {
  /* margin-top: 10%;
  margin-left: 15%; */
  /* width: 25%;
  height: 60%;   */
  width: 480px;
  height: 500px;  
  border-radius: 5px;
  background: linear-gradient(121deg, rgba(61, 122, 171, 0.5) 15%, rgba(37, 40, 88, 0.5) 84%);
  box-sizing: border-box;
  border: 1px solid;
  border-image: linear-gradient(36deg, #27A0E1 0%, rgba(39, 160, 225, 0) 32%, rgba(39, 160, 225, 0) 67%, #27A0E1 100%) 1;
  display: flex;
  flex-direction: column;
  align-items: center;
 }
 .title {
  color: #FFFFFF;
  font-weight: 700; 
  font-size: 34px;
  margin-top: 7%;
 }
 .fTiele {
  color: #FFFFFF;
  font-size: 16px;
  margin-top: 10px;
 }
 .item {
  width: 80%;
  margin-top: 24px;
 }
 .login_select_box{
  border-bottom: 1px solid #404040;
 }
 .textItem {
    padding: 10px 0;
    color: #999;
    font-size: 14px;
    margin-right: 20px;
    cursor: pointer;
 }
 .inputSty ::v-deep .el-input__inner {
  background-color: transparent;
  border: none;
 }
 .boxInput {
  background-color: #FFFFFF;
  display: flex;align-items: center;width: 100%;
  margin-top: 20px;
  border-radius: 5px;
 }
 .box_input_icon{
  width: 18px;
  height: 18px;
  margin-left: 13px;
 }
 .text {
  white-space: nowrap;
  margin-left: 6px;
  font-size: 16px;
  color: #999999;
  padding: 0 10px;
  box-sizing: border-box;
 }
 .loginSty {
  width: 100%;
  height: 48px;
  border-radius: 5px;
  background: linear-gradient(90deg, #008EFE 0%, #1A65CD 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  cursor: pointer;
 }
 .getCodeBtn{
  color: #00D1FF;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
  margin-right: 10px;
 }
 .login_agree_box{
  margin: 26px 0;
  font-size: 13px;
 }
</style>

